import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import WebsiteList from './components/WebsiteList';
import TimestampDetails from './components/TimestampDetails';

function App() {
    return (
        <Router>
            <div className="App">
                <Switch>
                    <Route path="/" exact component={WebsiteList} />
                    <Route path="/website/:websiteName/timestamp/:timestamp" component={TimestampDetails} />
                </Switch>
            </div>
        </Router>
    );
}

export default App;